var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('user-info-wrapper',{attrs:{"header":"Check your email","headerDescription":"We have sent a sign up email to your inbox.","showBackArrow":false,"showEmailSentIcon":true,"showSignInLink":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }